import React, { useState, useMemo } from "react"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import ReactSelect from "react-select"
import Notify from "../Componentslogic/Usenotifications"
import UsefetchCollectionAdmin from "../Componentslogic/Usefetchcollection"
import Spinner from "react-bootstrap/Spinner"
import { Adminreviewscard } from "./Adminseereviews"

const Adminreviewsconatiner = () => {
  const {
    data: reviews,
    loading,
    nextPage,
    hasMore,
  } = UsefetchCollectionAdmin("Reviews")

  const [filterOption, setFilterOption] = useState(null)

  const handleExtract = async () => {
    if (reviews.length > 0) {
      const reviewsData = reviews.map((review, index) => ({
        id: index + 1,
        "Client-Name": review.userName,
        "Client-Email": review.useremail,
        Comment: review.text,
        "Service-Rating": review.ratingService,
        "Food-Rating": review.ratingFood,
        Date: new Date(review.createdAt.seconds * 1000).toLocaleString(),
      }))

      const worksheet = XLSX.utils.json_to_sheet(reviewsData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reviews")

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" })
      saveAs(blob, "reviews.xlsx")
      Notify("Extracted", "success")
    } else {
      Notify("No reviews to extract", "error")
    }
  }

  // Filter reviews by selected option
  const filteredReviews = useMemo(() => {
    if (!filterOption) return reviews

    const sortedReviews = [...reviews]
    if (filterOption.value === "highest") {
      sortedReviews.sort(
        (a, b) =>
          (b.ratingService + b.ratingFood) / 2 -
          (a.ratingService + a.ratingFood) / 2
      )
    } else if (filterOption.value === "lowest") {
      sortedReviews.sort(
        (a, b) =>
          (a.ratingService + a.ratingFood) / 2 -
          (b.ratingService + b.ratingFood) / 2
      )
    }

    return sortedReviews
  }, [reviews, filterOption])

  const filterOptions = [
    { value: "highest", label: "Highest Rating" },
    { value: "lowest", label: "Lowest Rating" },
  ]

  return (
    <div className="dashboard-container">
      <main className="main-content">
        <header className="header">
          <h2>Total Reviews: {reviews.length}</h2>
          <div className="d-flex align-items-center">
            <ReactSelect
              options={filterOptions}
              onChange={(option) => setFilterOption(option)}
              placeholder="Filter by Rating"
              className="filter-select mx-2"
            />
            <button className="btns-Admin" onClick={handleExtract}>
              Extract to Excel
            </button>
          </div>
        </header>

        <section className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Client Name</th>
                <th>Client Phone</th>
                <th>Comment</th>
                <th>Service Rating</th>
                <th>Food Rating</th>
                <th>Date</th>
                <th>Order type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredReviews.map((review) => (
                <Adminreviewscard key={review.id} reviews={review} />
              ))}
            </tbody>
          </table>
        </section>

        {loading && (
          <Spinner animation="grow" variant="primary" className="spinner">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}

        {hasMore && !loading && (
          <div className="d-flex justify-content-center align-items-center">
            <button className="btns-Admin" onClick={nextPage}>
              Load More
            </button>
          </div>
        )}
      </main>
    </div>
  )
}

export default Adminreviewsconatiner
